import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class NewsletterThankYouPage extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get closeButtonText() {
    return get(this, '_close_button_text.value', '');
  }

  get backButtonText() {
    return get(this, '_back_button_text.value', '');
  }

  get successTitle() {
    return get(this, '_success_title.value', '');
  }

  get successLine1() {
    return get(this, '_success_line1.value', '');
  }

  get successLine2() {
    return get(this, '_success_line2.value', '');
  }

  get warningTitle() {
    return get(this, '_warning_title.value', '');
  }

  get warningLine1() {
    return get(this, '_warning_line1.value', '');
  }

  get warningLine2() {
    return get(this, '_warning_line2.value', '');
  }

  get errorTitle() {
    return get(this, '_error_title.value', '');
  }

  get errorLine1() {
    return get(this, '_error_line1.value', '');
  }

  get errorLine2() {
    return get(this, '_error_line2.value', '');
  }

  get confirmedTitle() {
    return get(this, '_confirmed_title.value', '');
  }

  get confirmedLine1() {
    return get(this, '_confirmed_line1.value', '');
  }

  get confirmedLine2() {
    return get(this, '_confirmed_line2.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/NewsletterThankYouPage.model.js